import { Box, Flex } from '@chakra-ui/layout';
import { Spinner } from '@chakra-ui/spinner';
import { FC } from 'react';
import { Crucible } from 'types';
import { useWeb3React } from 'hooks/web3';
import { useConfig } from 'store/config';
import NFT from './NFT';
import CrucibleMembership from 'components/crucible/CrucibleMembership';
import ArtworkUnavailable from 'components/crucible/ArtworkUnavailable';
import { webglSupport } from 'utils/checkWebgl';
import WebglUnavailable from 'components/crucible/WebglUnavailable';

type Props = {
  crucible: Crucible;
  readOnly: boolean;
};

const View: FC<Props> = ({ crucible, readOnly }) => {
  const { chainId = 1, account } = useWeb3React();
  const { artworkWhitelist } = useConfig(chainId).commonConfig;
  const hasWebglSupport = webglSupport();

  if (!crucible) {
    return <Spinner />;
  }

  if (crucible.membership === 'basic') {
    return <CrucibleMembership crucible={crucible} readOnly={readOnly} />;
  }

  if (!hasWebglSupport) {
    return <WebglUnavailable />;
  } else {
    if (chainId === 1 || (account && artworkWhitelist.includes(account))) {
      return (
        <Flex flexDir='column'>
          <Box bg='gray.900' borderRadius='md' overflow='hidden' py={0}>
            <NFT crucible={crucible} />
          </Box>
        </Flex>
      );
    }
  }

  return <ArtworkUnavailable chainId={chainId} />;
};

export default View;
